import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import IdleTimer from "react-idle-timer"

const IdleTimeOutModal = () => {
  // const onUnload = e => {
  //   // the method that will be used for both add and remove event
  //   e.preventDefault()
  //   e.returnValue = ""
  // }

  React.useEffect(() => {
    //window.addEventListener("beforeunload", onUnload)
    window.onbeforeunload = function() {
      return "Are you sure want to leave this page?"
    }
  }, [])

  const [remindTimeout, setRemindTimeout] = useState(600000) // 10 mins || 600 second
  const [showRemindModal, setShowRemindModal] = useState(false)
  const [isTimedOutRemind, setIsTimedOutRemind] = useState(false)

  const [timeout, setTimeout] = useState(900000) // 15mins || 900 second: 
  const [showModal, setShowModal] = useState(false)
  const [isTimedOut, setIsTimedOut] = useState(false)

  let remindIdleTimer = null
  let idleTimer = null

  const onAction = e => {
    setIsTimedOutRemind(false)
    setIsTimedOut(false)
  }

  const onActive = e => {
    setIsTimedOutRemind(false)
    setIsTimedOut(false)
  }

  const onIdleToBeRemind = e => {
    setShowRemindModal(true)
    setIsTimedOutRemind(true)
    window.onbeforeunload = null
  }

  const onIdle = e => {
    //console.log("user is idle", e)
    // if (isTimedOut) {
    //   //this.props.history.push("/")
    // } else {
    //   setShowModal(true)
    //   idleTimer.reset()
    //   setIsTimedOut(true)
    // }

    setShowModal(true)
    //idleTimer.reset()
    setIsTimedOut(true)
    //window.removeEventListener("beforeunload", onUnload)
    window.onbeforeunload = null
  }

  const handleClose = () => {
    //setShowModal(false)
    return null
  }

  return (
    <>
      <IdleTimer
        ref={ref => {
          remindIdleTimer = ref
        }}
        //element={document}
        onActive={onActive}
        onIdle={onIdleToBeRemind}
        onAction={onAction}
        debounce={250}
        timeout={remindTimeout}
      />
      <IdleTimer
        ref={ref => {
          idleTimer = ref
        }}
        //element={document}
        onActive={onActive}
        onIdle={onIdle}
        onAction={onAction}
        debounce={250}
        timeout={timeout}
      />
      <Modal
        show={showRemindModal && !showModal} // show={showModal}
        animation={true}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title>Page About Expire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You are idle for 10 minutes, click 'Extend' to continue your session</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <button
              type="button"
              className="btn btn-simple confirmRefresh col-xs-6"
              style={{margin: "auto"}}
              onClick={() => setShowRemindModal(false)}
            >
              Extend
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModal} // show={showModal}
        animation={true}
        onHide={handleClose}
        // id="confirm"
        // tabindex="-1"
        // role="dialog"
        // aria-labelledby="myModalLabel"
        // aria-hidden="true"
      >
        <Modal.Header>
          <Modal.Title>Page Expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Page expired due to inactivity on page.</p>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-simple confirmRefresh col-xs-6"
              onClick={() => window.location.reload(false)}
            >
              Refresh Page
            </button>

            <button
              type="button"
              className="btn btn-simple confirmLeave col-xs-6"
              onClick={() =>
                (window.location =
                  "https://www.etiqa.com.sg/claims/submit-claims/")
              }
            >
              Leave This Page
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
export default IdleTimeOutModal
